import React from 'react';
import classNames from 'classnames';
import { PencilLine } from 'lucide-react';
import { NamedLink } from '../../../../components';
import buttonCss from '../../../LandingPage/components/HomepageButtons.module.css';

// import ReviewsFilter from '../ReviewsFilter';
import css from './ReviewsSubHeader.module.css';

const ReviewsSubHeader = props => {
  const { className, rootClassName } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      {/* Add Review Button */}
      <div className={css.addReviewSection}>
        <NamedLink
          name="AddMyReviewPage"
          className={`${css.addReviewButton} ${buttonCss.button} ${buttonCss.buttonPrimary} ${buttonCss.buttonDark}`}
        >
          <PencilLine
            className={`${css.addReviewIcon} ${buttonCss.icon}`}
            size={16}
            strokeWidth={2}
            aria-hidden="true"
          />
          <span className={css.addReviewText}>ADD A REVIEW</span>
        </NamedLink>
      </div>
    </div>
  );
};

export default ReviewsSubHeader;
